import React from 'react';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { Toggle } from 'src/components/Toggle';
import { ContractTermSection } from 'src/components/shared/ContractTermSection';
import { IPrsDeductionCap } from 'src/types/IRateCard';

interface IViewCapPRSDeduction {
    prsDeductionCap?: IPrsDeductionCap;
}

export const ViewCapPRSDeduction = ({ prsDeductionCap }: IViewCapPRSDeduction) => {
    return (
        <ContractTermSection title={'Cap PRS deductions'}>
            <Toggle
                label="Enable allowable deduction caps for performance rights societies"
                value={true}
                isEditMode={false}
            />
            <Row widths="50%">
                <Column spacing="100">
                    <Text type="b200">PRS Model</Text>
                    <Text type="b300">Percentage of Royalties</Text>
                </Column>
                <Column spacing="100">
                    <Text type="b200">Percentage</Text>
                    <Text type="b300">{`${parseFloat(
                        (parseFloat((prsDeductionCap?.value || 1).toString()) * 100).toFixed(2)
                    )}%`}</Text>
                </Column>
            </Row>
        </ContractTermSection>
    );
};
